import { PopoverTrigger } from 'src/components/PopoverTrigger';
import Iconify from 'src/components/iconify';
import { useSnackbar } from 'src/components/snackbar';
import { useLocales } from 'src/locales';
import { useLivekitRTCState } from 'src/provider/VoiceChannel/livekit/useLivekitRTCState';
import { answerAudio } from 'src/requests/ai';
import { SoundBoardData, SoundBoardRequests } from 'src/requests/soundboard';
import { AskToAiButton } from 'src/sections/@dashboard/chat/ChatVoiceChannel/VoiceChannelControls/Buttons/AskToAiButton/AskToAiButton';
import { useSocketIO } from 'src/socket';
import { getImageFromVideo } from 'src/utils/getImageFromVideo';
import { useActionBarState } from '../../ActionsBar/useActionBarState';
import { useGatheringChatState } from '../../GatheringSessions/gatheringChatState';
import { SoundBoardPopover } from '../GatheringSpacesSoundBoard/SoundBoardPopover';
import { CustomActionButton, CustomButtonsContainer } from './styles';

export const GatheringSpacesActions = () => {
  const { translate } = useLocales();
  const { io } = useSocketIO();
  const { enqueueSnackbar } = useSnackbar();

  const { setSessionId, sessionId } = useGatheringChatState();
  const { openAction, setOpenAction, setIsOpen } = useActionBarState();

  const {
    toggleHandRaised,
    localParticipant,
    activeVoiceChannel,
    myMeetId,
    activeSessionId,
  } = useLivekitRTCState();

  const handleAskToAI = async (file: File) => {
    if (!myMeetId) return;
    const image = getImageFromVideo(myMeetId);
    try {
      await answerAudio(activeVoiceChannel.channel._id, file, image);
    } catch (e) {
      io.emit(`/voice-channel/unlock-ai`, {
        channelId: activeVoiceChannel.channel._id,
      });
      enqueueSnackbar(translate('shared.snackbar.failed_to_ask_ai'), {
        variant: 'error',
      });
    }
  };

  const handlePlaySound = (sound: Partial<SoundBoardData>) => {
    SoundBoardRequests.playSound({
      channelId: activeVoiceChannel.channel._id,
      soundId: sound._id!,
      icon: sound.icon!,
    });
  };

  const isChatOpened =
    openAction === 'gatheringChat' && sessionId === activeSessionId;

  const handleOpenChat = () => {
    if (!activeSessionId) return;
    if (isChatOpened) {
      setIsOpen(false);
      return;
    }
    setSessionId(activeSessionId);
    setOpenAction('gatheringChat');
  };

  return (
    <CustomButtonsContainer>
      <AskToAiButton isFromNav onSend={handleAskToAI} />
      <CustomActionButton
        onClick={() => toggleHandRaised()}
        color={localParticipant.raisedHand ? 'warning' : 'inherit'}
        tooltip={
          localParticipant.raisedHand
            ? translate('communicate.rtc_controls.lower_hand')
            : translate('communicate.rtc_controls.raise_hand')
        }
      >
        <Iconify icon="tabler:hand-stop" />
      </CustomActionButton>
      <PopoverTrigger
        popover={SoundBoardPopover}
        context={{ onSelectSound: handlePlaySound }}
      >
        <CustomActionButton
          color="inherit"
          tooltip={translate('communicate.sound_board.title')}
        >
          <Iconify icon="tabler:speakerphone" />
        </CustomActionButton>
      </PopoverTrigger>
      <CustomActionButton
        color={isChatOpened ? 'primary' : 'inherit'}
        tooltip={translate('communicate.open_chat')}
        onClick={() => handleOpenChat()}
        disabled={!activeSessionId}
      >
        <Iconify icon="tabler:message" />
      </CustomActionButton>
    </CustomButtonsContainer>
  );
};
